import React from 'react';
import { useTranslation } from 'react-i18next';
import './Toast.css';

function Toast({ message, type = 'info', onClose }) {
  const { t } = useTranslation();
  
  return (
    <div className={`toast toast_${type}`} role="alert">
      <span>{message}</span>
      {onClose && (
        <button
          type="button"
          className="toastClose"
          onClick={onClose}
          aria-label={t('common.close')}
        >
          ×
        </button>
      )}
    </div>
  );
}

export default Toast;
